import { connect } from '@iris-platform/incontext';
import { withApollo } from 'react-apollo';
import {
  applySpec,
  complement,
  compose,
  either,
  ifElse,
  isEmpty,
  isNil,
  propOr,
  pathSatisfies,
} from 'ramda';
import { deleteKey, synchronizeKey, updateKey } from '../actions';
import { KeySpace } from '../components';

const mapStateToProps = applySpec({});

const isNotEmpty = complement(either(isNil, isEmpty));

const hasError = pathSatisfies(isNotEmpty, ['error', 'message']);

const isSelected = propOr(false, 'isSelected');

const mapDispatchToProps = (dispatch, { client, domainOrToken }) => ({
  onKeyChange: compose(dispatch, updateKey(domainOrToken)),
  onKeyDelete: deleteKey(dispatch, client, domainOrToken),
  onKeySave: ifElse(
    hasError,
    compose(dispatch, updateKey(domainOrToken)),
    synchronizeKey(dispatch, client, domainOrToken),
  ),
  onKeySelect: ifElse(
    isSelected,
    (key) => {
      dispatch(updateKey(domainOrToken, key.set({ isSelected: false })));
      setTimeout(() => dispatch(updateKey(domainOrToken, key.clear())), 300);
    },
    key => synchronizeKey(dispatch, client, domainOrToken, key.set({ isSelected: true })),
  ),
});

const KeySpaceContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeySpace);

export default withApollo(KeySpaceContainer);
